export enum PurchaseOrderDeliveryType {
  Warehouse = 'warehouse',
  SalesOrder = 'salesOrder',
}
